/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react"
import PropTypes from "prop-types"
import { useIntl } from "gatsby-plugin-intl"
import H from "components/atoms/H"
import P from "components/atoms/P"
import Checkbox from "components/atoms/Checkbox"
import Project from "../Project"

import {
  StyledWrapper,
  StyledTextWrapper,
  StyledProjecsWrapper,
  StyledProjectList,
  StyledTitleWrapper,
  headingStyles,
  textStyles,
  titleStyles,
  StyledCheckboxWrapper,
} from "./WatchList.styles"

const WatchList = ({ projectList, toggleSelection, toggleAll }) => {
  const { formatMessage } = useIntl()

  return (
    <StyledWrapper data-testid="subscribeWatchList">
      <StyledTextWrapper data-testid="subscribeWatchListTextWrapper">
        <H
          as="h3"
          extraStyles={headingStyles}
          data-testid="subscribeWatchListTextTitle"
        >
          {formatMessage({ id: "subscriptionModal.watchList.titleP1" })}
          <span>
            {formatMessage({ id: "subscriptionModal.watchList.titleP2" })}
          </span>
        </H>
        <P
          extraStyles={textStyles}
          data-testid="subscribeWatchListTextParagraph"
        >
          {formatMessage({ id: "subscriptionModal.watchList.textP1" })}
          <b>{formatMessage({ id: "subscriptionModal.watchList.textP2" })}</b>
        </P>
      </StyledTextWrapper>
      <StyledProjecsWrapper data-testid="subscribeWatchListProjectWrapper">
        <StyledTitleWrapper data-testid="subscribeWatchListProjectTitle">
          <H as="h3" extraStyles={titleStyles}>
            {formatMessage({
              id: "subscriptionModal.watchList.createWatchlist",
            })}
          </H>
          <StyledCheckboxWrapper data-testid="subscribeWatchListProjectSelectAllCheckbox">
            <Checkbox
              id="selectAll"
              onClick={toggleAll}
              labelText={formatMessage({
                id: "subscriptionModal.watchList.selectAll",
              })}
            />
          </StyledCheckboxWrapper>
        </StyledTitleWrapper>

        <StyledProjectList data-testid="subscribeWatchListProjectList">
          {projectList.map((project) => (
            <Project
              project={project}
              key={project.id}
              isSelected={!!project.selected}
              toggleSelection={() => toggleSelection(project.id)}
            />
          ))}
        </StyledProjectList>
      </StyledProjecsWrapper>
    </StyledWrapper>
  )
}
WatchList.propTypes = {
  projectList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      selected: PropTypes.bool,
      overview: PropTypes.shape({
        city: PropTypes.shape({
          name: PropTypes.string,
          stateCode: PropTypes.string,
        }),
      }),
      bannerImages: PropTypes.arrayOf(
        PropTypes.shape({
          image: PropTypes.oneOfType([
            PropTypes.shape({
              original: PropTypes.string,
              large: PropTypes.string,
              medium: PropTypes.string,
              small: PropTypes.string,
            }),
            PropTypes.string,
          ]),
          id: PropTypes.string,
        })
      ),
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  toggleSelection: PropTypes.func.isRequired,
  toggleAll: PropTypes.func.isRequired,
}
export default WatchList
